export default "__VITE_ASSET__mZ_i1zOr__"